const trimZero = str => str.replace(/^(0*:){0,2}0?/g, '');

export default trimZero;



/** WEBPACK FOOTER **
 ** ./src/utils/trimZero.js
 **/